var render, staticRenderFns
import script from "./FromNow.vue?vue&type=script&lang=js&"
export * from "./FromNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27f248",
  null
  
)

export default component.exports